import app from 'flarum/forum/app';
import PostListSource from './PostListSource';
import { relatedId } from './realtimeEvents';

/**
 * Posts by members of a group, via Deck's `authorGroup` filter. Realtime posts
 * are placed from the author's groups when the payload carries them, and left
 * to the server when it doesn't.
 */
export default class GroupPostsSource extends PostListSource {
  constructor(groupId) {
    super({
      filter: {
        authorGroup: groupId
      }
    });
    this.groupId = groupId;
  }
  matches(post) {
    return this.inGroup(relatedId(post, 'user'));
  }
  mayMatchNewDiscussion(discussion) {
    return this.inGroup(relatedId(discussion, 'user'));
  }

  /** Decided from the author's groups when the store has them, otherwise by the server. */
  inGroup(userId) {
    const user = userId ? app.store.getById('users', userId) : null;
    const groups = user ? user.groups() : null;
    if (!Array.isArray(groups)) return undefined;
    return groups.some(group => group?.id() === this.groupId);
  }
}
flarum.reg.add('flarum-deck', 'forum/columns/GroupPostsSource', GroupPostsSource);